/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Button, Card, Icons, PageState } from '@myob/myob-widgets';
import somethingWentWrong from 'assets/images/somethingWentWrong.svg';
import { trackClickInErrorPage } from 'pages/ErrorPages/helper';
import { openInNewTab } from 'helpers/tools';
import { useRegionConfig } from '../../../../hooks/useRegionConfig';

export type Props = {
    parentPage: string;
};

export const ErrorComponent: React.FC<Props> = ({ parentPage }) => {
    const { HELP_LINK } = useRegionConfig();
    const handleClick = () => {
        trackClickInErrorPage('support', parentPage);
        openInNewTab(HELP_LINK);
    };
    return (
        <div data-testid="somethingWentWrong">
            <Card>
                <PageState
                    title="Something went wrong"
                    description={[
                        'Try reloading this page.',
                        <p key="contact support">If the issue persists, contact MYOB support.</p>,
                    ]}
                    actions={[
                        <Button key={1} type="link" icon={<Icons.Help />} onClick={handleClick}>
                            Contact our support team
                        </Button>,
                    ]}
                    image={<img src={somethingWentWrong} alt="Something Went Wrong" />}
                />
            </Card>
        </div>
    );
};

export default ErrorComponent;
